import { FC } from 'react';

import { Box } from '@bonusly/design-system';

/**
 * Falling Snow Effect
 * Creates subtle, ambient snowfall animation with sparse white circles
 * Designed to be non-distracting - very few particles, slow movement
 */
export const FallingSnow: FC = () => {
	// Generate only 12 snow particles for a subtle, ambient effect
	const items = Array.from({ length: 12 }, (_, i) => {
		const startX = Math.random() * 100;
		const duration = 20 + Math.random() * 25; // 20-45 seconds (slower)
		const delay = Math.random() * 30; // 0-30 second delay for more stagger
		const size = 3 + Math.random() * 6; // 3-9px circles (smaller)
		const swayAmount = 20 + Math.random() * 40; // 20-60px horizontal sway (gentler)
		const opacity = 0.25 + Math.random() * 0.35; // 0.25-0.6 opacity (more subtle)

		return {
			id: i,
			startX,
			duration,
			delay,
			size,
			swayAmount,
			opacity,
		};
	});

	return (
		<Box position="fixed" top={0} left={0} right={0} width="100%" height="100vh" pointerEvents="none" zIndex={9999} overflow="hidden">
			<style>
				{`
					@keyframes snowfall {
						0% {
							transform: translateY(-100px) translateX(0);
							opacity: 0;
						}
						5% {
							opacity: var(--snow-opacity);
						}
						95% {
							opacity: var(--snow-opacity);
						}
						100% {
							transform: translateY(calc(100vh + 50px)) translateX(var(--sway-amount));
							opacity: 0;
						}
					}

					.winter-snowflake {
						position: absolute;
						top: -100px;
						background-color: white;
						border-radius: 50%;
						animation: snowfall var(--duration) linear var(--delay) infinite;
						will-change: transform, opacity;
					}
				`}
			</style>
			{items.map((item) => (
				<Box
					key={item.id}
					className="winter-snowflake"
					left={`${item.startX}%`}
					width={`${item.size}px`}
					height={`${item.size}px`}
					style={
						{
							'--duration': `${item.duration}s`,
							'--delay': `${item.delay}s`,
							'--sway-amount': `${item.swayAmount}px`,
							'--snow-opacity': item.opacity,
						} as React.CSSProperties
					}
				/>
			))}
		</Box>
	);
};
